class ShopFeed extends HTMLElement {
    constructor() {
        super();
        this.currentVideoPlayer = this._getAutoPlayVideoElement() ? this._getAutoPlayVideoElement() : null;

        this.addEventListener(
            'video_playing',
            this.handleVideoPlaying.bind(this)
        );
        if (this.currentVideoPlayer && this.hasAttribute('play-first-media')) {
            this.addEventListener(_EVENT_HELPER.elementIsInCurrentView, (e) => {
                this.currentVideoPlayer._play();
            });
        }

        // this.addEventListener('video_paused', (e) => {
        //     if (this.currentVideoPlayer === e.target) {
        //         this.currentVideoPlayer = null;
        //     }
        // });
        HELPER_UTIL.trigerElementFunctionalityInView(
            this,
            null,
            this.checkInView.bind(this)
        );

        // Pause feed video if options drawer opens
        document.addEventListener(_EVENT_HELPER.showDrawer, (e) => {
            if (e.detail.drawerType !== 'options') return;
            this.checkAndPauseAnyVideoPlaying();
        });

        this.addEventListener('shoppable-feed-slide-change', (e) => {
            !e.detail.activeSlide.querySelector('feed-player') && this.checkAndPauseAnyVideoPlaying();

        });
    }

    handleVideoPlaying(e) {
        const newVideoPlayer = e.target;
        if (!this.currentVideoPlayer) {
            this.currentVideoPlayer = newVideoPlayer;
        }
        if (this.currentVideoPlayer && this.currentVideoPlayer != newVideoPlayer) {
            this.currentVideoPlayer._pause();
            this.currentVideoPlayer = newVideoPlayer;

        }
    }

    checkAndPauseAnyVideoPlaying() {
        if (!this.currentVideoPlayer) return;
        this.currentVideoPlayer._pause();
    }

    checkInView(e) {
        this.checkAndPauseAnyVideoPlaying();
    }

    _getAutoPlayVideoElement() {
        return [...this.querySelectorAll('feed-player')].find((el) =>
            el.hasAttribute('feed-media-autoplay')
        );
    }


}

customElements.get('shop-feed') || customElements.define('shop-feed', ShopFeed);

class ShoppableFeedCard extends HTMLElement {
    constructor() {
        super();
        this.mediaPlayElement = this.querySelector('[media-interaction-element]');
    }

    initCommonEventListeners() {
        this.mediaPlayElement && this.mediaPlayElement.addEventListener("click", (e) => {
        })
    }

    connectedCallback() {
        this.initCommonEventListeners();
    }

}

customElements.get('shoppable-feed-card') ||
    customElements.define('shoppable-feed-card', ShoppableFeedCard);
class FeedPlayer extends defaultVideoPlayer {
    constructor() {
        super();
        this.pauseVideoEl = this.querySelectorAll('[pause-media]');
        this.audioEl = this.querySelector('[audio-state]');
        this.playOnHover = this.hasAttribute("play-on-hover")
        this.pauseVideoEl &&
            this.pauseVideoEl.forEach((el) =>
                el.addEventListener('click', this.whenVideoPause.bind(this))
            );
        this.audioEl && this.audioEl.addEventListener('click', this.handleAudioState.bind(this));
        this.playOnHover && this.addEventListener("mouseenter", this.playONMouseHover.bind(this))
        this.playOnHover && this.addEventListener("mouseleave", this.pauseONMouseLeve.bind(this))
    }
    playONMouseHover() {
        if (this.getAttribute("video-playing") == 'false') {
            // Mute or unmute based on audio state
            const audioState = this.audioEl ? this.audioEl.getAttribute('audio-state') : 'mute';
            if (audioState === 'unmute') {
                this.player.muted = false;
            } else {
                this.player.muted = true;
            }
            // this.player.loop = true;
            this._play();

        }



    }
    pauseONMouseLeve() {
        this._pause()

    }
    handleAudioState() {
        const audioState = this.audioEl.getAttribute('audio-state');
        switch (audioState) {
            case 'mute':
                this.audioEl.setAttribute('audio-state', 'unmute');
                this.player.muted = false;
                break;
            case 'unmute':
                this.audioEl.setAttribute('audio-state', 'mute');
                this.player.muted = true;
                break;
            case 'default':
                break;
        }
    }


    whenVideoPause() {
        this._pause();
        // this.showPlayButton();
    }

    _pause() {
        super._pause();
        this.setAttribute("video-playing", false)
        // this.removeAttribute('media-autoplay');
        // HELPER_UTIL.dispatchCustomEvent('video_paused', this);
    }

    _play() {
        // Add 'media-autoplay' attribute to the currently playing element (this)
        // this.setAttribute('media-autoplay', '');

        // // When autoplay is enabled, ensure audio is muted
        // if (this.hasAttribute('feed-media-autoplay')) {
        this.player.muted = true;
        // Update audio state attribute to reflect muted state
        if (this.audioEl) {
            this.audioEl.setAttribute('audio-state', 'mute');
        }
        // }

        HELPER_UTIL.dispatchCustomEvent('video_playing', this);
        super._play();
        this.setAttribute("video-playing", true);
        // this.setAttribute('media-autoplay', '');

    }

    showPlayButton() {
        this.playButton.classList.remove('video-elements-hidden');
    }
}

customElements.get('feed-player') || customElements.define('feed-player', FeedPlayer);

class ShoppableCarouselComponent extends CarouselComponent {
    constructor() {
        super();
        this.shopFeedElement = this.closest('shop-feed');
    }

    handleFunctionalityAfterSlideChange(swiperInstance) {
        super.handleFunctionalityAfterSlideChange(swiperInstance);
        if (!this.hasAttribute("centered-slides")) return;
        HELPER_UTIL.dispatchCustomEvent('shoppable-feed-slide-change', this.shopFeedElement, {
            activeSlide: swiperInstance.slides[swiperInstance.activeIndex]
        });
    }
}

customElements.get('shoppable-carousel-component') || customElements.define('shoppable-carousel-component', ShoppableCarouselComponent);